import { useEffect } from 'react'
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import './UserProfile.css'
import useApiGet from "../hooks/getData"
import Cookies from 'js-cookie'
import Empty from '../../assets/empty.png'

function Following({ open, handleClose }) {
  const { data, loading, error, refetch, getData } = useApiGet();
  const userId = Cookies.get("userId")
  const handleGetFollowers = async () => {
    try {
      const response = await getData("/users/audiencesin", { to_user_id: userId })
    } catch (error) {

    }
  }

  useEffect(() => {
    handleGetFollowers();
  }, [userId]);


  const FollowingList = data?.data.audiencesin_details

  console.log("Followers @@@", FollowingList)
  const LikeList = [
    {
      name: "Alena",
      username: "_alena_",
    }
  ]

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth className='custom-user'>
        <div className="flex items-center justify-between pt-4 pr-5 pl-9 dark:bg-primary">
          <h2 className="text-[#000000] font-semibold text-xl font-poppins dark:text-darkText">AudiencesIn</h2>
          {/* <img
                src={Cross}
                alt="Close"
                className="w-10 h-10 cursor-pointer"
                onClick={handleClose}
              /> */}
          <button onClick={handleClose} className="text-2xl text-gray-600 dark:text-white">
            ×
          </button>
        </div>
        <DialogContent className='bg-white dark:bg-primary'>
          {FollowingList?.length > 0 ? (
            <>
              <div className='overflow-y-auto '>
                {FollowingList?.map((follower) => (
                  <>
                    <div className="flex items-center border-b dark:border-[#1F1F1F] border-[#EFEFEF] justify-between p-2 rounded-md light:hover:bg-gray-100">
                      <div className='flex'>
                        <img src={follower.audition_photo_url || "/assets/default_user.png"} alt={follower.username} className="w-12 h-12 mr-3 rounded-full" />
                        <div className='flex flex-col py-2 text-left'>
                          <p className='font-poppins text-[#000000] text-sm text-left dark:text-darkText font-semibold'> {follower.first_name} {follower.last_name}</p>
                          <p className="text-[#747474] font-poppins text-xs text-left">{follower.username}</p>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </>
          ) :
            (<>
              <div className='flex flex-col justify-center place-items-center min-h-[400px]'>
                <img src={Empty} className='w-16 h-16 ' />
                <p className='text-[#000000] text-opacity-[59%] font-poppins flex justify-center'>User does not have audiencesIn</p>
              </div>
            </>)}


        </DialogContent>
      </Dialog>
    </>
  )
}

export default Following;